import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PasswordValidation from '../components/PasswordValidation';
import * as rules from '../utils/ValidationPassword';

export default class PasswordForm extends Component {

    constructor(props) {
        super(props);

        this.state = {
              password1: '',
              password2: ''
        };
    }

    static propTypes = {
        texts: PropTypes.object.isRequired,
        lang: PropTypes.string.isRequired,
        handleSubmit: PropTypes.func.isRequired,
        validatePassword: PropTypes.func.isRequired,
        canSubmit: PropTypes.bool
    };

    _onChange(event) {
        let key = event.target.name;
        let password1, password2;

        if (key === 'password1') {
            this.setState({password1: event.target.value});
            password1 = event.target.value;
            password2 = this.state.password2;
        }
        else if (key === 'password2') {
            this.setState({password2: event.target.value});
            password1 = this.state.password1;
            password2 = event.target.value;
        }

        if (!this.props.canSubmit && this.validateLocaly(password1, password2)){
           this.props.validatePassword(password1);
        }

    }

    _onSubmit(event) {
        event.preventDefault();
        this.props.handleSubmit(this.state.password1);
        this.setState({password1: '', password2: ''});
    }

    validateLocaly(password1, password2) {
      let result = false;
      result = rules.validateMatch(password1, password2) &&
        rules.validateLength(password1, 10) &&
        rules.validateCharExists(password1) &&
        rules.validateDigitExists(password1);

      return result;
    }

    render() {
        let password1 = this.state.password1;
        let password2 = this.state.password2;


        let validation = (<PasswordValidation password1={password1}
                                              password2={password2}
                                              lang={this.props.lang} />);

        let disable = !(this.props.canSubmit && this.validateLocaly(password1, password2));
        let button = (<input type="submit"
                    disabled={disable}
                    value={this.props.texts.submit}
                    className="btn btn-default" />);

        return (
            <div>
             <form onSubmit={this._onSubmit.bind(this)}>
                <div className="form-group">
                    <label>{this.props.texts.label_password}</label>
                    <div className="input-group">
                        <span className="input-group-addon" id="basic-addon1">
                                <span className="glyphicon glyphicon-hand-right" aria-hidden="true"></span>
                            </span>
                        <input type="password"
                               value={password1}
                               name="password1"
                               className="form-control input-lg"
                               placeholder={this.props.texts.placeholder_password}
                               onChange={this._onChange.bind(this)}
                               />
                    </div>
                </div>
                <div className="form-group">
                    <label>{this.props.texts.label_password2}</label>
                    <div className="input-group">
                        <span className="input-group-addon" id="basic-addon1">
                                <span className="glyphicon glyphicon-hand-right" aria-hidden="true"></span>
                        </span>
                        <input type="password"
                               value={password2}
                               name="password2"
                               className="form-control input-lg"
                               placeholder={this.props.texts.placeholder_password}
                               onChange={this._onChange.bind(this)}
                               />
                    </div>
                </div>
               {button}
            </form>
            {validation}
            </div>
            );
  }
}
